import { render, staticRenderFns } from "./Divers.vue?vue&type=template&id=3974d36a&"
import script from "./Divers.vue?vue&type=script&lang=js&"
export * from "./Divers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports